import request from '@/utils/request'

export function getWaterMarkList (params) {
  return request({
    url: '/v2/sec/contractAdmin/getWaterMarkList',
    method: 'post',
    data: params
  })
}
export function createContract (params) {
  return request({
    url: '/v2/sec/insertWm/createContract',
    method: 'post',
    data: params
  })
}
export function createBarcode (params) {
  return request({
    url: '/v2/sec/insertWm/createBarcode',
    method: 'post',
    data: params
  })
}
export function createContractThumbnail (params) {
  return request({
    url: '/v2/sec/insertWm/createContractThumbnail',
    method: 'post',
    data: params
  })
}
export function deleteContractThumbnail (params) {
  return request({
    url: '/v2/sec/insertWm/deleteContractThumbnail',
    method: 'post',
    data: params
  })
}
export function directUploadWm (data) {
  return request({
    url: '/v2/sec/insertWm/directUploadWm',
    method: 'post',
    data
  })
}
export function registSignature (data) {
  return request({
    url: '/v2/sec/insertWm/registSignature',
    method: 'post',
    data
  })
}

export function deleteWaterMark (params) {
  return request({
    url: '/v2/sec/contractAdmin/deleteWaterMark',
    method: 'post',
    data: params
  })
}

export function uploadWaterMark (data) {
  return request({
    url: '/v2/sec/contractAdmin/upload',
    method: 'post',
    data
  })
}
